import "./modal.scss";

import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getFontSizeInRangeLimit } from "../../constants/styles/dimensions";
import { preferencesSelectors } from "../../modules/preferences";
import { PropTypeShapes } from "../../types";

const ModalFooter = props => (
  <div className="modalFooter" style={{ fontSize: getFontSizeInRangeLimit(props.globalFontSize) }}>
    {props.children}
  </div>
);

ModalFooter.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired,
  globalFontSize: PropTypes.number.isRequired
};

const mapStateToProps = state => {
  return {
    globalFontSize: preferencesSelectors.getGlobalFontSize(state.present)
  };
};

export default connect(mapStateToProps, null)(ModalFooter);
